import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { LocationBar } from 'components';
import { useToastNofication } from 'context/toastContext';
import { EditEventAttendeeInput, CreateEventAttendeeInput } from '__generated__/graphql';
import { useCreateEventAttendee } from 'api/hooks/useEventAttendee';
import { EventAttendeeForm } from './EventAttendeeForm';

function EventAttendeeCreateForm() {
  const { createEventAttendee, createEventAttendeeLoading, createEventAttendeeError } = useCreateEventAttendee();
  const navigate = useNavigate();
  const { addToast } = useToastNofication();

  const onSubmit = async (input: CreateEventAttendeeInput | EditEventAttendeeInput) => {
    const response = await createEventAttendee({
      variables: {
        input,
      },
    });
    addToast(response, 'CreateEventAttendee');
    if (!createEventAttendeeLoading && !createEventAttendeeError) {
      navigate('/event-attendees');
    }
  };

  return (
    <>
      <Helmet>
        <title>Event Attendee Create</title>
      </Helmet>
      <LocationBar section="Event Attendee" page="Event Attendee Create Form" Icon={ReviewsIcon} />
      <div className="my-10 px-4 md:px-[5%]">
        <button
          data-cy="event-attendees-detail-back"
          type="button"
          className="text-gray-500 font-semibold text-md leading-md flex items-center"
          onClick={() => navigate('/event-attendees')}
        >
          <ArrowLeftIcon className="mr-2 w-5 h-5" /> Back
        </button>
        <EventAttendeeForm onSubmit={onSubmit} formSubmitting={false} formSubmitError={undefined} />
      </div>
    </>
  );
}

export default EventAttendeeCreateForm;
